import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import APIs from "../redux/apiUrl";
import "swiper/css";
import "swiper/css/pagination";

const DynamicTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setLoading(true);
        const response = await APIs.get("/get_all_review/1/10");
        if (response.data?.data?.docs) {
          setTestimonials(response.data.data.docs);
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  return (
    <section className="testimonial__section position__relative testimonial__bg--two section--padding">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="testimonial__section--inner">
              <div className="section__heading text-center mb-40">
                <h2 className="section__heading--maintitle">What Our Top Clients Say</h2>
              </div>
              {loading ? (
                <p className="text-center">Loading testimonials...</p>
              ) : testimonials.length > 0 ? (
                <Swiper
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                pagination={{ clickable: true }}
                loop={testimonials.length > 1}
                modules={[Pagination, Autoplay]}
                className="flex justify-center items-center w-full lg:!bottom-2 !bottom-7"
              >
                {testimonials.map((review) => (
                  <SwiperSlide key={review._id} className="flex justify-center items-center">
                    <div className="testimonial__items--style2 flex flex-col items-center text-center border-radius-5">
                      <div className="testimonial__thumbnail--style2 flex justify-center items-center">
                        <img
                          className="testimonial__items--thumbnail__img display-block lg:ml-8 ml-6"
                          src={review.pic_image || "assets/img/other/user.png"}
                          alt={review.name}
                        />
                      </div>
                      <div className="testimonial__content--style2 flex-col justify-center items-center">
                        <h3 className="testimonial__items--author__title h4">{review.name}</h3>
                        <h4 className="testimonial__items--author__subtitle h5">{review.adminName}</h4>
                        <p className="testimonial__items--desc style2">{review.review || "No review available."}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              
              ) : (
                <p className="text-center">No testimonials available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicTestimonials;